<aside class="sidepanel">
  <header class="sidepanel__head">
    <app-icon name="table" size="18" />
    <span class="sidepanel__title">{{ T.title }}</span>
    <button class="iconbtn iconbtn--bare" [title]="S['Close']" (click)="dismiss.emit()" [attr.aria-label]="S['Close']">
      <app-icon name="close" size="16" />
    </button>
  </header>

  <div class="sidepanel__body">
    <label class="field">
      <span class="field__label">{{ S['Apply to range'] }}</span>
      <input class="input" [value]="range" readonly [attr.aria-label]="S['Apply to range']" />
    </label>
    <label class="field">
      <span class="field__label">{{ T.separator }}</span>
      <select class="input" (change)="choose($event)" [attr.aria-label]="T.separator">
        @for (s of separators; track s.key) {
          <option [value]="s.key" [selected]="choice() === s.key">{{ s.label }}</option>
        }
      </select>
    </label>
    @if (choice() === 'custom') {
      <label class="field">
        <span class="field__label">{{ T.custom }}</span>
        <input class="input" maxlength="1" [value]="custom()" (input)="setCustom($event)" [attr.aria-label]="T.custom" />
      </label>
    }
  </div>

  <footer class="sidepanel__foot">
    <span class="sidepanel__spacer"></span>
    <button class="btn btn--ghost" (click)="dismiss.emit()" [attr.aria-label]="S['Cancel']">{{ S['Cancel'] }}</button>
    <button class="btn btn--primary" [disabled]="delimiter() === null" (click)="emitSplit()" [attr.aria-label]="T.split">{{ T.split }}</button>
  </footer>
</aside>
